module.exports = __webpack_public_path__ + "static/media/notification-icon.8083d54a.svg";